import IconBase, { IconBaseProps } from "./IconBase";

const RemoveFromGroupIcon = (props: IconBaseProps) => (
  <IconBase {...props}>
    <g
      transform="translate(10, 10) rotate(-90) translate(-10, -10)"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M11,3 L15,3 C16.1045695,3 17,3.8954305 17,5 L17,15 C17,16.1045695 16.1045695,17 15,17 L5,17 C3.8954305,17 3,16.1045695 3,15 L3,11"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(10, 10) rotate(180) translate(-10, -10)"
      />
      <rect
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        x="6"
        y="6"
        width="5"
        height="5"
        rx="2.5"
      />
      <path
        d="M14,13 L17,13 C17.5522847,13 18,13.4477153 18,14 L18,17 C18,17.5522847 17.5522847,18 17,18 L14,18 C13.4477153,18 13,17.5522847 13,17 L13,14 C13,13.4477153 13.4477153,13 14,13 Z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </IconBase>
);

export default RemoveFromGroupIcon;
